var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNoSharePreset)?_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('div',{staticClass:"font-italic py-2 px-3 d-inline-block no-share"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('profile.create.infoSharing'))}})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }